import { OfferApi } from './http-common';

export const findAllSites = () => new Promise((resolve, reject) => {
  OfferApi.get('sites',  { headers: { 'Authorization': `Bearer ${localStorage.getItem('vue-token')}` } })
    .then(response => resolve(response.data))
    .catch(error => reject(error));
});
